import Dropzone, { DropzoneProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: DropzoneProps = {
  onDrop: () => {},
  children: [
    <Dropzone.Overlay>
      <span />
    </Dropzone.Overlay>,
    <Dropzone.Content>
      <span />
    </Dropzone.Content>,
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as DropzoneProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
